import { ProductSlimResponseDTO } from '@shared/DTO';
import { resolveProductContent, ProductAspect, ProductContentImage } from '../product-content/productContent.model';

export type GuideMode = 'inherit' | 'custom' | 'hide';
export interface GuideOverride<T> { mode: GuideMode; value?: T; }
export type GuideAspect = ProductAspect;
export type GuideImage = ProductContentImage;
export interface GuideSection {
  productId: string;
  anchor: string;
  title?: GuideOverride<string>;
  image?: GuideOverride<GuideImage>;
  descriptionPoints?: GuideOverride<string[]>;
  pros?: GuideOverride<string[]>;
  cons?: GuideOverride<string[]>;
  aspects?: GuideOverride<GuideAspect[]>;
}
export interface GuideConfig { source: string; sections: GuideSection[]; }

export function resolveGuideOverride<T>(base: T | undefined, override?: GuideOverride<T>): T | undefined {
  if (!override || override.mode === 'inherit') return base;
  if (override.mode === 'hide') return undefined;
  return override.value;
}

/** A view of the product for this guide only; the cached DTO is never changed. */
export function resolveGuideProduct(product: ProductSlimResponseDTO, section: GuideSection) {
  const base = resolveProductContent(product);
  return {
    title: resolveGuideOverride(base.title, section.title),
    image: resolveGuideOverride(base.image, section.image),
    descriptionPoints: resolveGuideOverride(base.descriptionPoints, section.descriptionPoints),
    pros: resolveGuideOverride(base.pros, section.pros),
    cons: resolveGuideOverride(base.cons, section.cons),
    aspects: resolveGuideOverride(base.aspects, section.aspects),
  };
}
